import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RequestModalProps from "@/app/interfaces/props/RequestModalProps";
import { LoadingStatusEnum } from "@/enums/loadingStatusEnum";
import BorderedInputLansing from "@/app/components/shared/BorderedInput";

const RequestModal = ({
  onClose,
  onSend,
  open,
  id,
  branchEmail,
  userEmail,
  dialogTitle,
  subjectPrefix,
  promptText,
  commentsLabel,
  statusChange,
  returnRequest,
  loadingStatus,
}: RequestModalProps) => {
  const [note, setNote] = useState<string>("");
  const initialSubject = `${subjectPrefix} #${id}`;
  const [subject, setSubject] = useState<string>(initialSubject);

  useEffect(() => {
    if (open) {
      setNote("");
      setSubject(initialSubject);
    }
  }, [open, id, subjectPrefix, initialSubject]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSend({
      branchEmail,
      userEmail,
      subject,
      note,
      statusChange,
      returnRequest,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          {dialogTitle}
        </Typography>
        <IconButton onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box component="form" onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: "600", mb: 1, color: "#494440" }}
            >
              Branch
            </Typography>
            <BorderedInputLansing
              name="branch"
              value={branchEmail || ""}
              readOnly={true}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: "600", mb: 1, color: "#494440" }}
            >
              From
            </Typography>
            <BorderedInputLansing
              name="userEmail"
              value={userEmail || ""}
              readOnly={true}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: "600", mb: 1, color: "#494440" }}
            >
              Subject
            </Typography>
            <BorderedInputLansing
              name="Subject"
              value={subject || ""}
              onChange={(e) => setSubject(e.target.value)}
            />
          </Box>

          {promptText && (
            <Typography
              textAlign={"center"}
              variant="body2"
              color="text.secondary"
              sx={{ mt: 2, mb: 1 }}
            >
              {promptText}
            </Typography>
          )}
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", mb: 1, color: "#494440" }}
          >
            {commentsLabel}
          </Typography>
          <TextField
            value={note}
            onChange={(e) => setNote(e.target.value)}
            fullWidth
            multiline
            minRows={4}
          />
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            variant="outlined"
            sx={{ py: 1, px: 4 }}
            disabled={LoadingStatusEnum.LOADING === loadingStatus}
          >
            SEND
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default RequestModal;
